/*
 * Size chart：弹窗居中 + Adult/Kids 切换
 */
(function () {
  let lastFocus = null;

  function getModalFromLink(link) {
    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return null;
    return document.querySelector(href);
  }

  function setChartKind(modal, kind) {
    if (!modal || (kind !== 'adult' && kind !== 'kids')) return;
    modal.setAttribute('data-active-chart', kind);
    modal.querySelectorAll('[data-size-chart-tab]').forEach((btn) => {
      const on = btn.getAttribute('data-size-chart-tab') === kind;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.setAttribute('tabindex', on ? '0' : '-1');
    });
  }

  function openModal(modal) {
    if (!modal) return;
    lastFocus = document.activeElement;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    if (!modal.getAttribute('data-active-chart')) {
      modal.setAttribute(
        'data-active-chart',
        modal.getAttribute('data-size-chart-kind') || 'adult'
      );
    }
    setChartKind(modal, modal.getAttribute('data-active-chart'));
    modal.hidden = false;
    document.documentElement.classList.add('size-chart-open');
    const closeBtn = modal.querySelector('.product-size-chart-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('size-chart-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener(
    'click',
    (event) => {
      const tab = event.target.closest('[data-size-chart-tab]');
      if (tab) {
        event.preventDefault();
        event.stopPropagation();
        const modal = tab.closest('[data-size-chart-modal]');
        setChartKind(modal, tab.getAttribute('data-size-chart-tab'));
        return;
      }

      const link = event.target.closest('.product-size-chart-link');
      if (link) {
        const modal = getModalFromLink(link);
        if (!modal) return;
        event.preventDefault();
        openModal(modal);
        return;
      }

      const closer = event.target.closest('[data-size-chart-close]');
      if (closer) {
        const modal = closer.closest('[data-size-chart-modal]');
        closeModal(modal);
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-size-chart-modal]:not([hidden])').forEach(closeModal);
  });
})();
